import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import properties from 'helpers/config';

const fallbackLng = ['fr'];
const availableLanguages = ['en', 'fr', 'nl', 'de'];

i18n
  .use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: process.env.NODE_ENV !== 'production',
    // saveMissing: true,
    backend: {
      // path to post missing resources
      // addPath: 'configurator/locales/add/{{lng}}/{{ns}}',
      loadPath: '/configurator/locales/{{lng}}/{{ns}}.json',
      // // allow cross domain requests
      // crossDomain: false,
      //
      // // allow credentials on cross domain requests
      // withCredentials: false,
    },
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    lng: properties.language,
  });

export default i18n;
